import { isConvelioSupplier } from 'src/utils/helpers/AccountHelper';

import { useAppSelector } from '../../store/hooks';
import { selectUser } from '../slices/Auth';

/**
 * Whether the logged-in account is an internal Convelio supplier team
 * (Le Bourget / Heathrow). Used to gate internal-only information.
 */
export const useIsConvelioSupplier = (): boolean => {
  const user = useAppSelector(selectUser);
  return isConvelioSupplier(user?.account?.name);
};
